// 인증 헤더 생성
export const authHeader = () => {
    return {
        headers: {
            Authorization: `Bearer ${getToken()}`
        }
    };
};

// 토큰 저장
export const setToken = (token) => {
    localStorage.setItem('token', token);
};

// 토큰 가져오기
export const getToken = () => {
    return localStorage.getItem('token');
};

// 토큰 삭제 (로그아웃)
export const removeToken = () => {
    localStorage.removeItem('token');
};

// 토큰에서 payload 파싱
const parseToken = () => {
    const token = getToken();
    if (!token) return null;
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch {
        return null;
    }
};

// 토큰 만료 여부 확인
export const isTokenExpired = () => {
    const payload = parseToken();
    if (!payload) return true;
    return payload.exp * 1000 < Date.now();
};

// 로그인 여부 확인 (만료 체크 포함)
export const isLoggedIn = () => {
    if (!localStorage.getItem('token')) return false;
    if (isTokenExpired()) {
        removeToken();
        return false;
    }
    return true;
};

// 토큰에서 role 가져오기
export const getRole = () => {
    const payload = parseToken();
    if (!payload) return null;
    return payload.role;
};

// 관리자 여부 확인
export const isAdmin = () => {
    return getRole() === 'ADMIN';
};